import React, { useEffect, useState } from "react";
import { ViewAdminBrands } from "../utils/Api/ApiCalls";
import { useRecoilValue } from "recoil";
import { userState } from "../Services/RecoilAtoms";

const Brands = () => {
  const currentUser = useRecoilValue(userState);
  const [brandData, setBrandData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const ViewAllBrands = async () => {
    try {
      const response = await ViewAdminBrands(
        currentUser.data.info.id,
        currentUser.data.token
      );
      setBrandData(response.data);
      
    } catch (err) {
      return err;
    }
  };

  const searchBrands = async () => {
    try {
      const response = await fetch(
        // `http://localhost:7045/api/v1/brands/search?name=${searchTerm}`
        `https://backend.argone.ng/api/v1/brands/search?name=${searchTerm}`
      );
      const data = await response.json();
      //   
      
      setBrandData(data.data);
    } catch (err) {
      console.error("Error searching for brands:", err);
    }
  };

  useEffect(() => {
    ViewAllBrands();
  }, []);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    searchBrands();
  };

  return (
    <section class="content-main">
      <div class="content-header">
        <div>
          <h2 class="content-title card-title">Brand</h2>
          <p>Brand and vendor management</p>
        </div>
        <div>
          <a href="/brand-form" class="btn btn-primary">
            <i class="text-muted material-icons md-post_add"></i>Add New Brand
          </a>
        </div>
      </div>
      <div class="card mb-4">
        <header class="card-header">
          <div class="row gx-3">
            <div class="col-lg-4 mb-lg-0 mb-15 me-auto">
              <div>All Brands</div>
              {/* <form onSubmit={handleSearchSubmit}>
                <input
                  type="text"
                  placeholder="Search..."
                  className="form-control"
                  value={searchTerm}
                  onChange={handleSearchChange}
                />
              </form> */}
            </div>
            {/* <div class="col-lg-2 col-6">
              <div class="custom_select">
                <select class="form-select select-nice">
                  <option selected>Categories</option>
                  <option>Technology</option>
                  <option>Fashion</option>
                  <option>Home Decor</option>
                  <option>Healthy</option>
                  <option>Travel</option>
                  <option>Auto-car</option>
                </select>
              </div>
            </div>
            <div class="col-lg-2 col-6">
              <input type="date" class="form-control" name="" />
            </div> */}
          </div>
        </header>

        <div class="card-body">
          <div class="row gx-3">
            {brandData?.length >= 1 ? (
              <>
                {brandData?.map((props) => (
                  <div class="col-xl-2 col-lg-3 col-md-4 col-6" key={props.id}>
                    <figure class="card border-1">
                      <div class="card-header bg-white text-center">
                        <img
                          style={{
                            height: "70px",
                            width: "100%",
                            objectFit: "cover",
                          }}
                          // src={`http://localhost:7045/uploads/${props?.image[0]?.img}`}
                          src={`https://backend.argone.ng/uploads/${props?.image[0]?.img}`}
                          class="img-fluid"
                          alt="Logo"
                        />
                      </div>
                      <figcaption class="card-body text-center">
                        <h6 class="card-title m-0">{props.name}</h6>
                        <a href="#"> {props?.product?.length} items </a>
                      </figcaption>
                    </figure>
                  </div>
                ))}
              </>
            ) : (
              <div>No brand found</div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Brands;
